import { styled } from '@mui/material'

export const DynamicImageStyled = styled('picture', {
  name: 'DynamicImage',
  slot: 'dynamicImage',
  overridesResolver: (props, styles) => styles.dynamicImage,
})(() => ({
  objectFit: 'contain',
  '& img': {
    display: 'block'
  }
}))
